import React, { FC } from "react";
import MuiSkeleton from "@mui/material/Skeleton";
import Avatar from "@mui/material/Avatar";
import { Wrapper, Header, Content, Left, Right, VideoDetails } from "./Skeleton.elements";

const Skeleton: FC = () => {
  const animationType = "wave";

  return (
    <Wrapper>
      <Header>
        <MuiSkeleton animation={animationType} variant="text" sx={{ height: 32, width: "50%" }} />
        <MuiSkeleton animation={animationType} variant="circular">
          <Avatar />
        </MuiSkeleton>
      </Header>

      <Content>
        <Left>
          <MuiSkeleton animation={animationType} variant="rectangular" />
          <MuiSkeleton animation={animationType} variant="rectangular" />
        </Left>

        <Right>
          <MuiSkeleton animation={animationType} variant="rectangular" sx={{ flex: 9 }} />
          <VideoDetails>
            <MuiSkeleton animation={animationType} variant="rectangular" />
            <MuiSkeleton animation={animationType} variant="rectangular" />
          </VideoDetails>
        </Right>
      </Content>
    </Wrapper>
  );
};

export default Skeleton;
